const parse = {};

parse.parseFloat = function (value) {
  if (value) {
    var l = (value + "").length - (value + "").replace(/\./g, "").length;
    if (l > 1) {
      value = "";
    }
  }
  var ret = parseFloat((value + "").replace(/,/g, ""));

  if (isNaN(ret)) ret = 0;
  return ret;
};

parse.parseInt = function (value) {
  if (value) {
    var l = (value + "").length - (value + "").replace(/\./g, "").length;
    if (l > 1) {
      value = "";
    }
  }
  var ret = parseInt((value + "").replace(/,/g, ""));

  if (isNaN(ret)) ret = 0;
  return ret;
};

parse.parseDate = function (value) {
  if (value) {
    var date = new Date(value),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("/");
  }
  return "";
};

parse.formatBytes = function (value, decimals = 2) {
  if (value) {
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(value) / Math.log(k));

    return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  return "0 Bytes";
};

export default parse;
